export enum ReportProblemTypes {

    REQUEST_REPORT_PROBLEM = "REQUEST_REPORT_PROBLEM",
    REPORT_PROBLEM_SUBMITTED = "REPORT_PROBLEM_SUBMITTED",

}